export default {
    name: '2025推介会嘉宾',
    url: '/activity/invite', // rest接口表名
    query: '', // rest接口query参数
    export: true,
    // 列表渲染列
    columns: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {title: '姓名', dataIndex: 'username'},
            {title: '性别', dataIndex: 'sex', customRender: text => text ? (text == 1 ? '男' : '女') : '--'},
            {title: '手机号码', dataIndex: 'mobile'},
            {title: '是否签到', dataIndex: 'is_sign', customRender: text => text == 1 ? '是' : '否'},
            {title: '是否观看演出', dataIndex: 'is_receive', customRender: text => text == 1 ? '是' : '否'},
        ]
    },
    // 列表查询表单
    queryForm: [
        {
            key: 'username',
            label: '',
            component: 'a-input',
            props: {
                placeholder: '输入姓名查询',
            },
        },
        {
            key: 'is_sign',
            label: '',
            component: 'a-select',
            props: {
                options: [
                    { value: 1, label: '是' },
                    { value: 2, label: '否' },
                ],
                allowClear: true,
                placeholder: '选择是否签到筛选',
            },
            update: ['change'],
            style: {
                width: '180px'
            }
        },
    ],
    // 新增/编辑查询表单
    items: [
        {
            key: 'username',
            label: '姓名',
            component: 'a-input',
            props: {
                placeholder: '请输入姓名',
            },
            rules: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
        },
        {
            key: 'sex',
            label: '性别',
            component: 'a-radio-group',
            props: {
                options: [
                    { value: 1, label: '男' },
                    { value: 2, label: '女' },
                ],
            },
            rules: [{ required: true, message: '请选择性别', trigger: 'change' }]
        },
        {
            key: 'mobile',
            label: '手机号码',
            component: 'a-input',
            props: {
                placeholder: '请输入手机号码',
            },
            rules: [{ required: true, message: '请输入手机号码', trigger: 'blur' }]
        },
        {
            key: 'is_receive',
            label: '是否观看演出',
            component: 'a-radio-group',
            props: {
                options: [
                    { value: 1, label: '是' },
                    { value: 2, label: '否' },
                ],
            },
            rules: [{ required: true, message: '请选择是否观看演出', trigger: 'change' }]
        },
    ],
    // 详情接口expand字段
    expand: '',
    init: {}, // 新增实体初始化字段
    // 详情渲染字段
    renderItems: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {
                label: '姓名',
                key: 'username',
            },
            {
                label: '性别',
                slot: entity => <span>{ entity.sex == 1 ? '男' : '女'}</span>
            },
            {
                label: '手机号码',
                key: 'mobile',
            },
            {
                label: '是否签到',
                slot: entity => <span>{ entity.is_sign == 1 ? '是' : '否'}</span>
            },
            {
                label: '是否观看演出',
                slot: entity => <span>{ entity.is_sign == 1 ? '是' : '否'}</span>
            },
        ]
    }
}
